import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MarkdownView from '../../../../components/ui/MarkdownView/MarkdownView';
import classes from './LiveThinkingStream.module.css';

const TICK_MS = 20;
const CHARS_PER_TICK = 10;

export default function LiveThinkingStream({ text = '', isActive = true }) {
  const { texts } = useSelector((state) => state.translate);
  const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    if (!text) setVisibleCount(0);
  }, [text]);

  useEffect(() => {
    if (!text || visibleCount >= text.length) return undefined;

    const timer = window.setInterval(() => {
      setVisibleCount((current) => {
        if (current >= text.length) return current;
        const remaining = text.length - current;
        const step = remaining > 40
          ? Math.min(CHARS_PER_TICK + 2, remaining)
          : CHARS_PER_TICK;
        return Math.min(current + step, text.length);
      });
    }, TICK_MS);

    return () => window.clearInterval(timer);
  }, [text, visibleCount]);

  if (!isActive) return null;

  const visibleText = text.slice(0, visibleCount);
  const isWaitingForMore = isActive && visibleCount >= text.length;

  return (
    <div className={classes.Container}>
      {visibleText ?
        <MarkdownView className={classes.ThinkingMarkdown}>
          {visibleText}
        </MarkdownView>
        : null}
      {isWaitingForMore ?
        <div className={classes.ShimmerText}>{texts.thinkingFurther}</div>
        : null}
    </div>
  );
}
